import React from 'react';
import { defaultTemplate } from 'core/hoc';

function SliderCheckBoxTemplate({
	t,
	disabled,
	field,
	field: { label, id },
	customMessage,
	onChangeCallback,
	labelSuffix,
}) {
	const inputProps = { ...field.bind() };
	inputProps.disabled = disabled;
	if (onChangeCallback) {
		inputProps.onChange = e => {
			field.onChange(e);
			onChangeCallback(e);
		};
	}
	return (
		<div className="input--toggle__wrapper">
			<label className="display--b">
				{t(label)}
				{labelSuffix}
			</label>
			{customMessage && <span className="input--toggle__label">{customMessage} </span>}
			<input {...inputProps} className="input--toggle input--toggle--secondary" />
			<label htmlFor={id}></label>
		</div>
	);
}

export default defaultTemplate(SliderCheckBoxTemplate);
